export function inlineifyHTML(html) {
    const div = document.createElement("div");
    div.innerHTML = html;

    //block-level tags
    const blocks = div.querySelectorAll("p, div, li, ul, ol, h1, h2, h3, h4, h5, h6, br");

    blocks.forEach(node => {
        const span = document.createElement("span");
        span.innerHTML = node.innerHTML;
        node.parentNode.replaceChild(span, node);
    });

    return div.innerHTML; //flattened HTML
}
